// frontend/src/components/Modal.jsx
import React, { useEffect } from 'react';
import { useLanguageStore } from '../store/useLanguageStore'; // 🟢 Importamos el store

export const Modal = ({ isOpen, title, message, onClose, onAccept, showCancel }) => {
  const { t } = useLanguageStore(); // 🟢 Obtenemos la función traductora

  useEffect(() => {
    const handleEsc = (e) => { if (e.key === 'Escape') onClose(); };
    if (isOpen) window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-sm w-full p-6 animate-in zoom-in-95 duration-200">
        <h3 className="text-xl font-black text-slate-900 mb-2">{title}</h3>
        <p className="text-slate-500 text-sm mb-6">{message}</p>
        <div className="flex justify-end gap-3">
          {showCancel && (
            <button
              onClick={onClose}
              className="px-4 py-2 rounded-xl text-sm font-bold text-slate-600 hover:bg-slate-100 transition-colors"
            >
              {/* 🟢 Traducimos 'Cancelar' */}
              {t('common.buttons.cancel') || 'Cancelar'}
            </button>
          )}
          <button
            onClick={onAccept || onClose}
            className="px-4 py-2 rounded-xl text-sm font-bold bg-blue-600 text-white hover:bg-blue-700 transition-colors"
          >
            {/* 🟢 Traducimos 'Aceptar' */}
            {t('common.buttons.accept') || 'Aceptar'}
          </button>
        </div>
      </div>
    </div>
  );
};